import React from 'react'
import { useFormContext } from 'react-hook-form'

interface Props {
  prefix: string
  required: boolean
}

const HeightWeight: React.FC<Props> = ({ prefix, required }) => {
  const { register } = useFormContext()

  return (
    <>
      <div className="row">
        <div className="col">
          <table className="table table-borderless">
            <tbody>
              <tr>
                <td className="align-middle text-nowrap">身長</td>
                <td className="input-group">
                  <input
                    ref={register({
                      valueAsNumber: true,
                      required: required && '身長を入力してください',
                      min: {
                        value: 1,
                        message: '身長は1以上で入力してください',
                      },
                      max: {
                        value: 250,
                        message: '身長は250以下で入力してください',
                      },
                    })}
                    type="number"
                    inputMode="decimal"
                    name={`${prefix}.height_weight_value.height`}
                    step="0.1"
                    className="form-control border border-light bg-light"
                    aria-describedby={`${prefix}_height`}
                  />
                  <div className="input-group-append">
                    <span
                      className="input-group-text border-light bg-light"
                      id={`${prefix}_height`}
                    >
                      cm
                    </span>
                  </div>
                </td>
              </tr>
              <tr>
                <td className="align-middle text-nowrap">体重</td>
                <td className="input-group">
                  <input
                    ref={register({
                      valueAsNumber: true,
                      required: required && '体重を入力してください',
                      min: {
                        value: 1,
                        message: '体重は1以上で入力してください',
                      },
                      max: {
                        value: 250,
                        message: '体重は250以下で入力してください',
                      },
                    })}
                    type="number"
                    inputMode="decimal"
                    name={`${prefix}.height_weight_value.weight`}
                    step="0.1"
                    className="form-control border border-light bg-light"
                    aria-describedby={`${prefix}_weight`}
                  />
                  <div className="input-group-append">
                    <span
                      className="input-group-text border-light bg-light"
                      id={`${prefix}_weight`}
                    >
                      kg
                    </span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </>
  )
}

export default HeightWeight
